
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/document/marketing",
      function () {
        return require("private-next-pages/document/marketing.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/document/marketing"])
      });
    }
  